import React, { useState } from 'react';
import MonthInput from "./MonthInput";

const EstadoResultados = () => {
    // Estado para simular los movimientos (abonos y pagos)
    const [movements, setMovements] = useState([
        { id: 1, date: "2025-02-01", concept: "Abono Paciente Juan", debit: 0, credit: 300000, balance: 300000 },
        { id: 2, date: "2025-02-03", concept: "Pago Remuneración Auxiliar María", debit: 200000, credit: 0, balance: 100000 },
        { id: 3, date: "2025-02-05", concept: "Abono Paciente Carla", debit: 0, credit: 150000, balance: 250000 },
        { id: 4, date: "2025-02-07", concept: "Pago servicio médico", debit: 50000, credit: 0, balance: 200000 },
        { id: 5, date: "2025-02-10", concept: "Abono Paciente Raúl", debit: 0, credit: 100000, balance: 300000 },
        { id: 6, date: "2025-02-12", concept: "Pago Nómina Cuidadores", debit: 150000, credit: 0, balance: 150000 },
    ]);

    // Cálculos para el total de abonos y pagos
    const totalAbonos = movements.filter(m => m.credit > 0).reduce((acc, curr) => acc + curr.credit, 0);
    const totalPagos = movements.filter(m => m.debit > 0).reduce((acc, curr) => acc + curr.debit, 0);
    const diferencia = totalAbonos - totalPagos;

    return (
        <div className="container mt-4">
            <div className="card p-4 shadow">
                <h3 className="text-center mb-4">Estado de Resultados - Pacientes y Auxiliares</h3>

                {/* Filtros */}
                <div className="row mb-4">
                    <div className="col-12">
                        <MonthInput className="form-control" placeholder="Selecciona un mes" />
                    </div>
                </div>

                {/* Totales Abonos y Pagos */}
                <div className="row mb-4">
                    <div className="col-md-6">
                        <h5>Total Abonos: ${totalAbonos.toLocaleString()}</h5>
                    </div>
                    <div className="col-md-6">
                        <h5>Total Pagos: ${totalPagos.toLocaleString()}</h5>
                    </div>
                </div>

                {/* Tabla de Movimientos */}
                <div className="table-responsive">
                    <table className="table table-striped table-bordered">
                        <thead>
                            <tr>
                                <th>ID Movimiento</th>
                                <th>Fecha</th>
                                <th>Concepto</th>
                                <th>Debe</th>
                                <th>Abono</th>
                                <th>Saldo</th>
                            </tr>
                        </thead>
                        <tbody>
                            {movements.map((movement) => (
                                <tr key={movement.id}>
                                    <td>{movement.id}</td>
                                    <td>{movement.date}</td>
                                    <td>{movement.concept}</td>
                                    <td className={movement.debit > 0 ? 'text-danger' : ''}>
                                        {movement.debit > 0 ? `$${movement.debit.toLocaleString()}` : '-'}
                                    </td>
                                    <td className={movement.credit > 0 ? 'text-success' : ''}>
                                        {movement.credit > 0 ? `$${movement.credit.toLocaleString()}` : '-'}
                                    </td>
                                    <td>${movement.balance.toLocaleString()}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {/* Diferencia Final */}
                <div className="mt-4">
                    <h5>Diferencia: ${diferencia.toLocaleString()}</h5>
                </div>
            </div>
        </div>
    );
};

export default EstadoResultados;
